import { Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import PersonIconList from '../../../components/PersonIconList';
import TableCell from '../../../components/TableCell';
import Text from '../../../components/Text';
import TooltipIcon from '../../../components/TooltipIcon';
import TooltipTag from '../../../components/TooltipTag';
import { ProspectGroupListItemFragment } from '../../../generated/graphql';
import ConflictingSignups from './ConflictingSignups';
import { getAgeInYears } from '../../../helpers/dateTimeUtils';

type SignupType = ProspectGroupListItemFragment | ProspectGroupListItemFragment['memberSignups'][0];

export type GroupMemberListItemProps = {
  signup: SignupType;
};

const isLeaderSignup = (signup: SignupType): signup is ProspectGroupListItemFragment => 'memberSignups' in signup;

const GroupMemberListItem = ({ signup }: GroupMemberListItemProps) => {
  const prospect = isLeaderSignup(signup) ? signup.companion! : signup.soul!;
  const isSoul = !isLeaderSignup(signup);

  return (
    <tr>
      <TableCell>
        <TooltipIcon
          label={isSoul ? 'Genießer' : 'Begleiter'}
          icon={isSoul ? IconNames.HEART : IconNames.HAND}
          marginRight
        />
        {prospect!.display_name}
        {!!prospect.birthdate && <Text muted> ({getAgeInYears(prospect.birthdate).toString()})</Text>}
      </TableCell>
      <TableCell>
        {signup.is_first_attend && (
          <TooltipTag minimal intent={Intent.SUCCESS} label="Neu" tooltip="Erste Teilnahme" marginRight />
        )}
        <ConflictingSignups signups={signup.conflicting_signups} userName={prospect.display_name} />
        <PersonIconList person={prospect} />
        <br />
        <Text small muted>
          {signup.notes}
        </Text>
      </TableCell>
      <TableCell>{signup.priority}</TableCell>
    </tr>
  );
};

export default GroupMemberListItem;
